import { render } from "./Portfolio.vue?vue&type=template&id=0f026b75"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=0f026b75&lang=css"
script.render = render

export default script